import React, { useState, useEffect } from 'react';
import './otpsignup.scss';

const Login = ({ handleForgotPassword, showPassword, toggleShowPassword, handleSignUp }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [csrfToken, setCsrfToken] = useState('');

    useEffect(() => {
        // Get CSRF token from meta tag
        const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        setCsrfToken(metaToken || '');
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const fieldName = name.includes('[') ? name.split('[')[1].replace(']', '') : name;
        setFormData((prev) => ({
            ...prev,
            [fieldName]: value
        }));
    };

    return (
        <form
            action="/users/sign_in"
            method="POST"
            data-turbo="false"
            className="flex-col"
        >
            {/* CSRF Token */}
            <input type="hidden" name="authenticity_token" value={csrfToken} />

            {/* Email Input */}
            <div className="text-left">
                <label htmlFor="email" className="inline-block text-sm text-gray-500">
                    Email
                </label>
                <input
                    type="email"
                    id="email"
                    name="user[email]"
                    value={formData.email}
                    onChange={handleInputChange}
                    autoComplete="email"
                    required
                    className="block appearance-none w-full bg-white border border-gray-400 text-gray-700 py-3 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                />
            </div>

            {/* Password Input */}
            <div className="text-left mt-3">
                <label htmlFor="password" className="inline-block text-sm text-gray-500">
                    Password
                </label>
                <div className="relative">
                    <input
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        name="user[password]"
                        value={formData.password}
                        onChange={handleInputChange}
                        autoComplete="current-password"
                        required
                        className="block appearance-none w-full bg-white border border-gray-400 text-gray-700 py-3 px-4 pr-12 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-5 text-gray-700">
                        <button
                            type="button"
                            className="text-purple-500 hover:text-purple-800 focus:outline-none"
                            onClick={toggleShowPassword}
                        >
                            {showPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                        </button>
                    </div>
                </div>
            </div>

            {/* Forgot Password */}
            <p className="cursor-pointer mt-4 float-right text-purple-500 text-sm underline" onClick={handleForgotPassword}>Forgot password</p>

            {/* Submit */}
            <button type="submit" className="cursor-pointer text-sm px-32 py-3 bg-purple-500 text-white rounded-lg hover:bg-purple-800 mt-5 ml-1">
                Login
            </button>
            
            {/* Sign Up */}
            <p className="mt-4 text-sm text-center text-gray-500">
                Don't have an account?{' '}
                <span className="text-purple-500 cursor-pointer underline" onClick={handleSignUp}>Sign up now!</span>
            </p>
        </form>
    );
};

export default Login;
